import { FileText, ScrollText, Bot, Network, BookOpen, ListChecks, MessagesSquare, ArrowRight, Gift } from "lucide-react";
import { TOOLKIT } from "@/data/offers";
import { useDiagnostic } from "./DiagnosticContext";
import { Reveal } from "./Reveal";

export const TOOL_ICONS = {
  pdf: { I: FileText, c: "text-blue-700 bg-blue-50" },
  scripts: { I: ScrollText, c: "text-teal-700 bg-teal-50" },
  bot: { I: Bot, c: "text-sky-700 bg-sky-50" },
  map: { I: Network, c: "text-teal-700 bg-teal-50" },
  book: { I: BookOpen, c: "text-[#0B1B33] bg-slate-100" },
  checklist: { I: ListChecks, c: "text-blue-700 bg-blue-50" },
  chat: { I: MessagesSquare, c: "text-sky-700 bg-sky-50" },
};

const Tile = ({ t, big, i }) => {
  const { I, c } = TOOL_ICONS[t.icon];
  return (
    <Reveal delay={i * 0.06} className={big ? "col-span-2 md:col-span-1 md:row-span-2" : ""}>
      <div data-testid={`toolkit-item-${t.key}`}
        className={`card-lift group relative flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 ${big ? "md:p-6" : ""}`}>
        {big && <span className="absolute right-4 top-4 rounded-full bg-[#0B1B33] px-2.5 py-1 text-[11px] font-semibold text-white">Start here</span>}
        <span className={`grid place-items-center rounded-xl transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-110 ${c} ${big ? "h-16 w-16" : "h-11 w-11"}`}>
          <I className={big ? "h-8 w-8" : "h-5 w-5"} strokeWidth={1.7} />
        </span>
        <h3 className={`font-display mt-4 font-bold leading-tight text-[#0B1B33] ${big ? "text-[22px]" : "text-[15px]"}`}>{t.title}</h3>
        <p className={`mt-1.5 text-slate-600 ${big ? "text-[15px]" : "text-[13px] leading-snug"}`}>{t.text}</p>
        {big && <div className="mt-auto pt-6"><div className="h-2 overflow-hidden rounded-full bg-slate-100"><div className="h-full w-3/4 rounded-full bg-gradient-to-r from-[#0E9384] to-[#2563EB]" /></div><p className="mt-2 text-[12px] text-slate-600">Personalised from your 5 answers</p></div>}
      </div>
    </Reveal>
  );
};

export const WhatYouGet = () => {
  const { openToolkit } = useDiagnostic();
  return (
    <section id="toolkit" data-testid="what-you-get-section">
      <Reveal className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-display flex items-center gap-3 text-[24px] font-bold tracking-tight text-[#0B1B33]">
            What you'll get <span className="flex items-center gap-1 rounded-full bg-gradient-to-r from-[#0E9384] to-[#14B8A6] px-3 py-1 text-[12px] font-semibold text-white"><Gift className="h-3.5 w-3.5" /> Free AI Project Toolkit</span>
          </h2>
          <p className="mt-1 text-[14px] text-slate-600">Everything you need to go from learning to landing, in one free pack.</p>
        </div>
        <button data-testid="toolkit-section-cta-btn" onClick={openToolkit} className="group flex items-center gap-2 text-[14px] font-semibold text-[#0E9384]">
          Get the toolkit <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </button>
      </Reveal>
      <div className="mt-4 grid grid-cols-2 gap-3 md:auto-rows-fr md:grid-cols-4">
        {TOOLKIT.map((t, i) => <Tile key={t.key} t={t} big={i === 0} i={i} />)}
      </div>
    </section>
  );
};
